import script from "./UserFormModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserFormModal.vue?vue&type=script&setup=true&lang=ts"

import "./UserFormModal.vue?vue&type=style&index=0&id=215d80c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-215d80c2"]])

export default __exports__